import React, { useEffect, useState } from "react";
import TickIcon from "../../assets/icons/tick.svg2";
import { Button, Row } from "react-bootstrap";
import EngineerVisitIcon from "../../assets/icons/engineer.svg2";
import { Link } from "react-router-dom";
import JsonCollapse from "../Builder/Components/JsonCollapse";
import TemplateDetail from "../Library/TemplateDetail";
import {
  InboundCampaignType,
  useDeleteInboundCampaignMutation,
} from "../store/inboundCampaignSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { pageProps } from "../helpers/pageProps";
import { proxyAPI } from "../proxyAPI";

export default function InboundCampaignDetails({
  selectedTemplate,
}: {
  selectedTemplate: InboundCampaignType;
}) {
  const [projectData, setProjectData] = useState<any>();
  const selectedTemplateUuid =
    selectedTemplate.Uuid || (selectedTemplate as any).UUID;
  const keywords = Array.isArray(selectedTemplate.Keywords)
    ? selectedTemplate.Keywords
    : typeof selectedTemplate.Keywords === "string" && selectedTemplate.Keywords
    ? [selectedTemplate.Keywords]
    : [];

  const getProjectData = async (projectID: any) => {
    const projectData = await proxyAPI({
      prefix: "logic/workflows/api",
      url: `/project/${projectID}`,
      setLoading: () => null,
    });

    setProjectData(projectData);
  };

  useEffect(() => {
    if (!selectedTemplate.ProjectId || selectedTemplate.Do !== "run-project")
      return;

    getProjectData(selectedTemplate.ProjectId);
  }, [selectedTemplate.ProjectId]);

  return (
    <div className="my-3">
      <div
        className={`btn w-75 h-100 px-0  text-start rounded-3 position-relative `}
      >
        <div className="d-flex align-items-center">
          <div className="bg-purple-gradient rounded-circle me-3">
            <EngineerVisitIcon width={60} />
          </div>
          <div className="me-3">
            <h3 className="text-black fw-bold">{selectedTemplate.Label}</h3>
            <div className="text-secondary small">
              {selectedTemplate.Description}
            </div>
          </div>
        </div>
      </div>
      <div className="fw-bold my-4">Inbound Campaign Details</div>
      <Row>
        <div className="col-6">
          <TemplateDetail
            Icon={TickIcon}
            label="Reference"
            value={selectedTemplate.Reference}
          />
        </div>

        <div className="col-6">
          <TemplateDetail
            Icon={TickIcon}
            label="Channel"
            value={selectedTemplate.Channel}
          />
        </div>

        <div className="col-6">
          <TemplateDetail
            Icon={TickIcon}
            label="Inbound"
            value={
              selectedTemplate.Channel === "email"
                ? selectedTemplate.Inbound + "@" + pageProps.emailDomain
                : selectedTemplate.Inbound
            }
          />
        </div>

        <div className="col-6">
          <TemplateDetail
            Icon={TickIcon}
            label="Keywords"
            value={
              keywords.length > 0 ? keywords.join(", ") : "Handle all inbounds"
            }
          />
        </div>

        <div className="col-6">
          <TemplateDetail
            Icon={TickIcon}
            label="Created by"
            value={selectedTemplate.CreatedBy}
          />
        </div>
        <div className="col-6">
          <TemplateDetail
            Icon={TickIcon}
            label="Created at"
            value={selectedTemplate.CreatedAt}
          />
        </div>
        <div className="col-6">
          <TemplateDetail
            Icon={TickIcon}
            label="Updated at"
            value={selectedTemplate.UpdatedAt}
          />
        </div>
        {selectedTemplate.Do === "run-project" && projectData && (
          <>
            <div className="col-12">Connected to</div>
            <div className="col-6">
              <TemplateDetail
                Icon={TickIcon}
                label="Project label"
                value={
                  <>
                    {projectData.Label}
                    <Link to={`/builder/${projectData.ID}`} className="small ms-2">
                      <FontAwesomeIcon icon={faEdit} />
                    </Link>
                  </>
                }
              />
            </div>
            <div className="col-6">
              <TemplateDetail
                Icon={TickIcon}
                label="Project Description"
                value={projectData.Description}
              />
            </div>
            <div className="col-6">
              <TemplateDetail
                Icon={TickIcon}
                label="Project Reference"
                value={projectData.Reference}
              />
            </div>
            <div className="col-6">
              <TemplateDetail
                Icon={TickIcon}
                label="Created by"
                value={projectData.CreatedBy}
              />
            </div>
          </>
        )}
      </Row>

      <div className="fw-bold mt-4 pt-2">Please note:</div>
      <span className="text-secondary">
        Inbound emails are messages sent to your organization by users,
        typically for support, lead capture, or automated workflows.
      </span>
      <div className="d-flex justify-content-start my-5">
        <Link
          to={`/inbounds/${selectedTemplateUuid}`}
          className="btn bg-colored-reverse rounded-pill me-2"
        >
          <div className="d-flex align-items-center ">
            <TickIcon width={40} className=" white rounded-circle p-1" />
            <h5 className="my-0 mx-3 text-white">Edit this campaign</h5>
          </div>
        </Link>
      </div>

      <JsonCollapse json={selectedTemplate} />
    </div>
  );
}
